export default __webpack_public_path__ + "static/media/hht2_ep_05.2694ebcc.png";